import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';
import { inboxEntriesKeys } from '../../../Sidebar/api/getInboxEntries';
import { inboxSuggestionsKeys } from '../../../Header/FilterButtons/SearchFilter/api/getInboxSuggestions';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type DeleteFileDTO = {
  fileId: number;
};

export const deleteFile = ({ fileId }: DeleteFileDTO): Promise<UpdateFileEntryResponse> => {
  return axios.delete(generateRoutePath(url, { fileId }), {
    ...entryActionCustomValidateOptions,
  });
};

type useDeleteFileOptions = {
  projectId: string;
  config?: MutationConfig<typeof deleteFile>;
};

export const usePermanentDeleteFile = ({ projectId, config }: useDeleteFileOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (data.status === false) {
        return;
      }

      queryClient.invalidateQueries([
        ...inboxEntriesKeys.lists({ projectId }),
        ...inboxSuggestionsKeys.detail({ projectId })
      ]);
    },
    ...config,
    mutationFn: deleteFile,
  });
};
